import { ActionReducer, createReducer, on } from '@ngrx/store';
import { CategoryRestrictionProfileConfigurationApiActions } from './category-restriction-profile-configuration.actions';
import {
  adapter,
  CategoryRestrictionProfileConfigurationsState,
  initialState,
  selectId,
} from './category-restriction-profile-configuration.state';

export const categoryRestrictionProfileConfigurationReducer: ActionReducer<CategoryRestrictionProfileConfigurationsState> =
  createReducer(
    initialState,
    on(
      CategoryRestrictionProfileConfigurationApiActions.restrictionProfileConfigurationLoaded,
      (state, { configurations }) => {
        return adapter.setMany(configurations, state);
      }
    ),
    on(
      CategoryRestrictionProfileConfigurationApiActions.restrictionProfileConfigurationSet,
      (state, { category, configurations }) => {
        const intermediateState = adapter.removeMany((x) => selectId(x).includes(category.categoryId), state);
        return adapter.setMany(configurations, intermediateState);
      }
    )
  );

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectRestrictionProfileConfigurationsIds = selectIds;

export const selectRestrictionProfileConfigurationsEntities = selectEntities;

export const selectAllRestrictionProfileConfigurations = selectAll;
